import { useCallback, useContext } from "react";
import { useMutation, UseMutationOptions, useQueryClient } from "react-query";

import { IDeleteTravellerParams } from "../domain";
import { apiServiceContext } from "../../api-service-context";
import { EntityType } from "../query-keys";

export const useDeleteTravellers = (options?: UseMutationOptions<any, any, IDeleteTravellerParams>) => {
  const { travellersApiService } = useContext(apiServiceContext);
  const queryClient = useQueryClient();

  const mutationFn = useCallback(
    (payload: IDeleteTravellerParams) =>
      travellersApiService.createCancellableRequest((cancelToken) =>
        travellersApiService.deleteTraveller(payload, cancelToken)
      ),
    [travellersApiService]
  );

  const mutation = useMutation<any, any, IDeleteTravellerParams>(mutationFn, {
    ...options,
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries(EntityType.USER_TRAVELLERS);
      options?.onSuccess?.(...args);
    },
  });

  return mutation;
};
